import styled from '@emotion/styled';

import { colors } from '../../../src/styles/colors';
import { ZeeFontMedium, getInitialLoadIcons } from '../../styles/font';
import { MediaBP as MQ } from '../../styles/mediaQuery';
import { flex } from '../../styles/utils';
import { InitialLoadIconsSet } from '../../utils/constants/IconsConstants';

export const CrumbsContainer = styled.div`
  ${flex('row', 'left')}
`;
export const BreadCrumbsLink = styled.a`
  color: ${colors.TintedGrey30};
  ${ZeeFontMedium(12, 18)};
  :last-child {
    color: ${colors.TintedGrey50};
    pointer-events: none;
  }
  ${MQ.MediaSm} {
    ${ZeeFontMedium(14, 20)};
  }
  ${MQ.MediaXl} {
    ${ZeeFontMedium(16, 22)};
  }
`;
export const ChevronRight = styled.span`
  color: ${colors.TintedGrey50};
  ${getInitialLoadIcons(InitialLoadIconsSet.CHEVRON)};
  &::before {
    display: block;
    font-size: 1rem;
    transform: rotate(-90deg);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
`;
